import { ActionsUnion, createAction } from "common/reducers/UtilsTypes";
import { ILocationData } from "common/records/Location";

export const FETCH_LOCATION = "@location/FETCH_LOCATION";
export const RECEIVE_LOCATION = "@location/RECEIVE_LOCATION";
export const RECEIVE_LOCATIONS = "@location/RECEIVE_LOCATIONS";
export const RESET_LOCATION = "@location/RESET_LOCATION";
export const SET_LOCATION_LOADED = "@location/SET_LOCATION_LOADED";
export const DESTROY_LOCATION = "@location/DESTROY_LOCATION";
export const REMOVE_LOCATION = "@location/REMOVE_LOCATION";
export const ACTIVATE_LOCATION = "@location/ACTIVATE_LOCATION";

export const LocationActions = {
  fetchLocation: (locationId: string | number) => createAction(FETCH_LOCATION, { locationId }),
  receiveLocation: (location: ILocationData, pushToList?: boolean) =>
    createAction(RECEIVE_LOCATION, { location, pushToList }),
  receiveLocations: (locations: ILocationData[]) => createAction(RECEIVE_LOCATIONS, { locations }),
  resetLocation: (locationId: string | number) => createAction(RESET_LOCATION, { locationId }),
  setLocationLoaded: (locationId: string | number) => createAction(SET_LOCATION_LOADED, { locationId }),
  destroyLocation: (locationId: string | number) => createAction(DESTROY_LOCATION, { locationId }),
  removeLocation: (locationId: string | number) => createAction(REMOVE_LOCATION, { locationId }),
  activateLocation: (locationId: string | number) => createAction(ACTIVATE_LOCATION, { locationId }),
};

export type LocationActions = ActionsUnion<typeof LocationActions>;
